module.exports = __webpack_public_path__ + "img/logo.e983bb3c.png";